import { Component, OnInit } from '@angular/core';
import { ServerMapping } from './../../service/serverMapping.service';
import { AccountService } from './../../service/accountService.service';
import { Http } from '@angular/http';
import { RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { Locale } from './../../service/locale.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent {

    public visible = false;
    public visibleAnimate = false;
    
    public newPassword = '';
    public repeatPassword = '';
    
    public minPaswordLengthFlag = false;
    public maxPasswordLengthFlag = false;
    public capitalCharsMinFlag = false;
    public numberCharsMinFlag = false;
    public passwordMismatchFlag = false;
    public avoidFlag = false;

    public passwordError = false;
    public passwordChanged = false;
    public passwordChangeResultLabel = '';
    
    constructor(private locale: Locale, private accountService: AccountService, private serverMapping: ServerMapping, private http: Http) {}

    public show() {
        this.visible = true;
        setTimeout(() => this.visibleAnimate = true, 100);
        this.updateChecks();
        this.newPassword = '';
        this.repeatPassword = '';
    }

    public hide() {
        this.visibleAnimate = false;
        setTimeout(() => this.visible = false, 100);
    }

    public onContainerClicked(event: MouseEvent): void {
        if ((<HTMLElement>event.target).classList.contains('changepasswordModal')) {
            this.hide();
        }
    }

    public resetPassword() {
        let passwordWrong = false;
        let passwordResetSuccess = false;
        let passwordResetError = false;
        let waitingchangePassword = true;
        
        let params = {};
        params['username'] = this.accountService.getLoginName();
        params['password'] = btoa( this.newPassword );
        
        console.log(params);
        
        this.http.post(this.serverMapping.changePasswordURL, params).subscribe((response) => {
            const data = response.json();
            console.log(data);
            if (data.result === false) {
                this.passwordError = true;
                this.passwordChangeResultLabel = "Error: " + data.result_warning;
            } else {
                this.passwordError = false;
                this.passwordChangeResultLabel = this.getPswTerms().success;
            }
        });
    }
    
    public updateChecks() {
        this.minPasswordSizeCheck();
        this.maxPasswordSizeCheck();
        this.passwordMismatchCheck();
        this.avoidPasswordCheck();
        this.passwordError = false;
        this.passwordChangeResultLabel = '';
    }

    public buttonEnabled() {
        if (this.minPaswordLengthFlag === false && 
            this.maxPasswordLengthFlag === false &&
            this.passwordMismatchFlag === false &&
            this.avoidFlag === false) {
            return true;
        } else {
            return false;
        }
    }

    public minPasswordSizeCheck() {
        if (this.getPswParams().minPasswordLength > this.newPassword.length) 
        {
            this.minPaswordLengthFlag = true;
        }
        else
        {
            this.minPaswordLengthFlag = false;
        }
    }
    public maxPasswordSizeCheck() {
        if (this.getPswParams().maxPasswordLength < this.newPassword.length) 
        {
            this.maxPasswordLengthFlag = true;
        }
        else
        {
            this.maxPasswordLengthFlag = false;
        }
    } 
    public passwordMismatchCheck() {
        if (this.newPassword !== this.repeatPassword)
        { 
            this.passwordMismatchFlag = true; 
        } 
        else 
        { 
            this.passwordMismatchFlag = false; 
        }
    }
    public avoidPasswordCheck() {
        this.avoidFlag = false;
        for (const element of this.getPswParams().avoid.split(' ')) {
            if (element === this.newPassword) {
                this.avoidFlag = true;
                break;
            }
        }
    }
    
    public getMismatchErrorLabel() { return this.getPswTerms().passwordWrong; }
    public getAvoidLabel() { return this.getPswTerms().avoidPassword; }
    public getShortPasswordLabel() { return this.getPswTerms().passwordShort.replace("§", this.getPswParams().minPasswordLength.toString()); }
    public getLongPasswordLabel() { return this.getPswTerms().passwordShort.replace("§", this.getPswParams().maxPasswordLength.toString()); }

    // wrapper functions
    getTerms() { return this.locale.getTerms(); }
    
    getPswTerms() { return this.locale.getMiscTerms().changePassword; }
    getPswParams() { return this.locale.getPasswordParams(); }

}



// WEBPACK FOOTER //
// ./src/app/components/MODAL-change-password/change-password.component.ts